import React from "react";
import { Modal, Button } from "antd";
import {
  EyeOutlined,
  DownloadOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import Files from "../../assets/img/files.png";
import moment from "moment";
import { useTranslation } from "react-i18next";

interface ModalProps {
  isDownloadModalVisible: boolean;
  isPreviewModalVisible: boolean;
  handleDownloadModalCancel: () => void;
  handlePreviewModalCancel: () => void;
  handleOpenPreviewModal: () => void;
  processedFileURL: string;
  headerData: any;
  previewURL: string;
}

const DocumentModals: React.FC<ModalProps> = ({
  isDownloadModalVisible,
  isPreviewModalVisible,
  handleDownloadModalCancel,
  handlePreviewModalCancel,
  handleOpenPreviewModal,
  processedFileURL,
  headerData,
  previewURL,
}) => {
  const { t } = useTranslation("googleDrive");
  const formattedDate = headerData?.date
    ? moment(headerData.date).format("MMMM Do YYYY, h:mm:ss a")
    : "";
  console.log("headerData", headerData);
  return (
    <>
      <Modal
        visible={isDownloadModalVisible}
        onCancel={handleDownloadModalCancel}
        footer={null}
        centered
        style={{ minWidth: "750px" }}
      >
        <div style={{}}>
          <div style={{ textAlign: "start" }}>
            <Button
              type="link"
              onClick={handleDownloadModalCancel}
              style={{ marginTop: "20px" }}
              className="go-back-button"
            >
              <ArrowLeftOutlined /> {t("downloadModal.goBack")}
            </Button>
          </div>
          <h4
            style={{
              color: "#4A1C96",
              fontSize: "20px",
              fontFamily: "Poppins",
              textAlign: "center",
              marginBottom: "unset",
            }}
          >
            {t("downloadModal.ready")}
          </h4>
          <div
            style={{
              background: "#FAEEFF",
              border: "1px solid #FADCEA",
              borderRadius: "8px",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              padding: "24px",
              marginBottom: "1rem",
              marginTop: "1rem",
            }}
          >
            <h3
              style={{
                margin: "unset",
                color: "#4A1C96",
                fontSize: "18px",
                fontFamily: "Poppins",
                fontWeight: "600",
              }}
            >
              {t("downloadModal.documentDetails")}
            </h3>
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                flexDirection: "column",
              }}
            >
              <p style={{}}>{t("downloadModal.title")}</p>
              <span style={{ color: "#3A3737", fontWeight: "600" }}>
                {headerData?.title ?? ""}
              </span>
            </div>
            <div style={{ display: "flex", gap: "10rem" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  flexDirection: "column",
                }}
              >
                <p>{t("downloadModal.processedAt")}</p>
                <span style={{ color: "#3A3737", fontWeight: "600" }}>
                  {formattedDate ?? ""}
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  flexDirection: "column",
                }}
              >
                <p style={{}}>{t("downloadModal.numberOfPages")}</p>
                <span style={{ color: "#3A3737", fontWeight: "600" }}>
                  {headerData?.numPages ?? ""}
                </span>
              </div>
            </div>
          </div>

          <div
            style={{
              background: "#FAEEFF",
              border: "1px solid #FADCEA",
              borderRadius: "8px",
              padding: "1.5rem",
              marginBottom: "1rem",
              textAlign: "left",
            }}
          >
            <h4
              style={{
                margin: "unset",
                color: "#4A1C96",
                fontSize: "18px",
                fontFamily: "Poppins",
                fontWeight: "600",
              }}
            >
              {t("downloadModal.textPreprocessingOptions")}
            </h4>
            <div
              style={{
                marginBottom: "1rem",
                fontFamily: "Poppins",
                fontSize: "14px",
              }}
            >
              <p>
                {t("downloadModal.summaryIncluded")}{" "}
                <span style={{ color: "#3A3737", fontWeight: "600" }}>
                  {headerData.summaryIncluded ? t("downloadModal.yes") : t("downloadModal.no")}
                </span>
              </p>
              <p>
                {t("downloadModal.tokenizationType")}{" "}
                <span style={{ color: "#3A3737", fontWeight: "600" }}>
                  {headerData?.tokenizationType ?? ""}
                </span>
              </p>
              <p>
                {t("downloadModal.wordCount")}{" "}
                <span style={{ color: "#3A3737", fontWeight: "600" }}>
                  {headerData?.wordCount ?? ""}
                </span>
              </p>

              <p>
                {t("downloadModal.sentiment")}{" "}
                <span style={{ color: "#3A3737", fontWeight: "600" }}>
                  {headerData.sentiment}
                </span>
              </p>
              <div>
                <h4>{t("downloadModal.readabilityAnalysis")}</h4>
                <p>
                  {t("downloadModal.fleschReadingScore")}{" "}
                  <span style={{ color: "#3A3737", fontWeight: "600" }}>
                    {headerData?.readability?.fleschReadingScore ?? ""}
                  </span>
                </p>
                <p>
                  {t("downloadModal.gunningFogIndex")}{" "}
                  <span style={{ color: "#3A3737", fontWeight: "600" }}>
                    {headerData?.readability?.gunningFogIndex ?? ""}
                  </span>
                </p>
                <p>
                  {t("downloadModal.smogIndex")}{" "}
                  <span style={{ color: "#3A3737", fontWeight: "600" }}>
                    {headerData?.readability?.smogIndex ?? ""}
                  </span>
                </p>
              </div>
              <div>
                <h4>{t("downloadModal.entities")}</h4>
                {headerData?.entities?.length > 0 ? (
                  <ul>
                    {headerData.entities.map((entity: any, index: any) => (
                      <li key={index}>{JSON.stringify(entity)}</li>
                    ))}
                  </ul>
                ) : (
                  <p>{t("downloadModal.noEntities")}</p>
                )}
              </div>
            </div>
          </div>
          <div
            style={{
              background: "#F4D9FF",
              marginBottom: "2rem",
              padding: "1px 10px",
              borderRadius: "8px",
            }}
          >
            <p style={{ color: "#4A1C96", padding: "8px 0" }}>
              {t("downloadModal.note")}
            </p>
          </div>
          <div className="preview-download-div">
            <Button
              href={processedFileURL} // Keep if necessary for a fallback
              target="_blank"
              onClick={(e) => {
                e.preventDefault();
                handleOpenPreviewModal();
              }}
              style={{ marginRight: "10px" }}
              className="prev-button"
            >
              <EyeOutlined /> {t("downloadModal.preview")}
            </Button>

            <Button
              href={processedFileURL}
              download="processedFile.docx"
              className="process-button"
            >
              <DownloadOutlined /> {t("downloadModal.download")}
            </Button>
          </div>
        </div>
      </Modal>

      {/* <Modal
        title="Preview Document"
        visible={isPreviewModalVisible}
        onCancel={handlePreviewModalCancel}
        footer={null}
        width={800}
      >
        {previewURL ? (
          // Use an iframe to preview the document using Google Docs Viewer
          <iframe
            src={previewURL}
            style={{ width: "100%", height: "600px" }}
            frameBorder="0"
            allowFullScreen
          />
        ) : (
          <p>Preview not available for this file type.</p>
        )}
      </Modal> */}

      <Modal
        title={t("previewModal.title")}
        visible={isPreviewModalVisible}
        onCancel={handlePreviewModalCancel}
        footer={null}
        width={800}
      >
        {previewURL ? (
          <iframe
            src={previewURL}
            style={{ width: "100%", height: "600px" }}
            frameBorder="0"
            allowFullScreen
          />
        ) : (
          <div style={{ padding: 16 }}>
            <p>
              {t("previewModal.unavailable")}
            </p>
            <Button
              href={processedFileURL}
              target="_blank"
              icon={<DownloadOutlined />}
            >
              {t("previewModal.download")}
            </Button>
          </div>
        )}
      </Modal>
    </>
  );
};

export default DocumentModals;
